/**
 * 头像弹出层
 */

import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang/index';
import Modal from 'boron/ScaleModal';

const noop = function(){};

const style = {
    modalStyle: {
         width: '350px',
         zIndex: 1080
    },
    contentStyle: {
        width: '350px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.7)",
        zIndex: 1070
    },
    picStyle: {
        width: '100%',
        borderRadius: '6px',
        height: 'auto'
    }
}

class OverlayPop  extends Component {
    static defaultProps = {
        onHide: noop,
        src: '',
        closeOnClick: true
    }
    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.showModal();
    }

    onHide() {
        this.props.onHide();
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    render() {
        let modalStyle = style.modalStyle;
        let backdropStyle = style.backdropStyle;
        let contentStyle = style.contentStyle;
        
        if (this.props.modalStyle) {
            for (let style in this.props.modalStyle) {
                modalStyle[style] = this.props.modalStyle[style];
            }
        }

        if (this.props.backdropStyle) {
            for (let style in this.props.backdropStyle) {
                backdropStyle[style] = this.props.backdropStyle[style];
            }
        }

        if (this.props.contentStyle) {
            for (let style in this.props.contentStyle) {
                contentStyle[style] = this.props.contentStyle[style];
            }
        }

        return (
            <Modal 
                ref="modal" 
                closeOnClick={this.props.closeOnClick}
                modalStyle={modalStyle}  
                backdropStyle={backdropStyle} 
                contentStyle={contentStyle}
                onHide={this.onHide.bind(this)}
                className="J_PreviewPic"
            >
                <div className="overlay-pic-pop">
                    <div className="close" onClick={()=>this.hideModal()}>x</div>
                    <img src={this.props.src} style={style.picStyle}/>
                </div>
            </Modal>
        );
    }
}


module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <OverlayPop {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function(){
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/im/views/preview-pic.js